import * as assets from "./madnesAssetsAdapter";
import { getAudioTracks } from "../../framework/src/engine/madnes/MadnesAudio"
import * as madnes from "../../framework/src/engine/madnes/madnes";

import {madnes_set_win_factors} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_default_volume} from "../../framework/src/engine/madnes/madnes_audio";
import {
    set_madnes_coins_shift,
    set_show_money_pos_x,
    set_show_money_pos_y
} from "../../framework/src/engine/madnes/madnes_anims";
import {wi, he, to_load_audio_madnes} from "../../framework/src/engine/madnes/madnes_variables";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {ACTION_EVENTS} from "../../framework/src/ui/UserAction";
import {UISLIDER_EVENTS} from "../../framework/src/ui/mobile/sliders/AbstractUISlider";
import {EVENTS} from "../../framework/src/events/baseEvents";
import {j81_print_reels} from "../j81_core_printer";
import {
    j81_infomenu_close,
    j81_infomenu_init,
    j81_infomenu_left,
    j81_infomenu_open,
    j81_infomenu_right, j81_infomenu_update,
    openinfo
} from "../j81_infomenu";
import {j81_print_desk} from "../j81_reels";
import {j81_rotate_run} from "../j81_core";
import { main_phaser } from "../../framework/src/engine/madnes/MadnesApp";


export const infotexts_languages = [
    "cs", "en", "fr", "hr", "ro", "pl", "de", "fi", "no", "ru", "es", "sr", "sv", "tr", "nl", "it"
];

export function initGame(gameset) {

    set_madnes_coins_shift(-80);

    set_show_money_pos_x(wi / 2 - 40)
    set_show_money_pos_y(he / 2 + 20);

    madnes.set_ico_size(220, 172 + 7);

    madnes_set_win_factors(25, 50, 125);

    madnes_set_sprite("coins", 152, 152);

    madnes_set_sprite('_sprite', 216, 172);
    madnes_set_sprite('_blur', 216, 172);

    madnes_set_default_volume(0.8);

}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced(eventName, data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            infomenu_update();
            // soe_lines_close(data);
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function game_start() {
    main_phaser.tweens.frameBased = true;
    j81_rotate_run()
}

export function print_desk() {
    j81_print_desk()
}

export function print_reels() {
    j81_print_reels();
}

export function infomenu_init() {
    j81_infomenu_init();
}

export function infomenu_open() {
    j81_infomenu_open();
}

export function infomenu_close() {
    j81_infomenu_close();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    if(!openinfo) return;
    j81_infomenu_left();
}

export function infomenu_right() {
    if(!openinfo) return;
    j81_infomenu_right();
}

export function infomenu_update() {
    j81_infomenu_update();
}

export function end_round_recalced(eventName, {autostart}) {
    // soe_end_round_recalced();

    if(!autostart) {
        end_round_no_autostart();
    }
}

export function end_round_no_autostart() {}

function freespins_end_round(eventName, {ended}) {}

export function get_preinfo() {}

export function preinfo_close() {}